import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const MenuSetupService = {
  // Define your API functions here
  createType: async (data) => {
    const response = await apiService.post("/menutypes", data);
    return response.data;
  },
  updateType: async (id, updatedData) => {
    try {
      const response = await apiService.put(`/menutypes/${id}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  getType: async ({ page = 1, pageSize = 10 }) => {
    const params = new URLSearchParams({
      page: page.toString(),
      pageSize: pageSize.toString(),
    });

    const response = await apiService.get(`/menutypes?${params.toString()}`);
    return response.data;
  },
  getTypeDetail: async (id) => {
    const response = await apiService.get(`/menutypes/${id}`);
    return response.data;
  },
  getByTypeIds: async (ids) => {
    const params = new URLSearchParams();

    ids.forEach((id) => {
      params.append("ids", id);
    });

    const response = await apiService.get(
      `/menutypes/by-ids?${params.toString()}`
    );
    return response.data;
  },

  deleteType: async (id) => {
    const response = await apiService.delete(`/menutypes/${id}`);
    return response.data;
  },

  // Define your API functions here
  create: async (data) => {
    const response = await apiService.post("/menu", data);
    return response.data;
  },
  update: async (updatedData) => {
    try {
      const response = await apiService.put(`/menu`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  get: async () => {
    // const params = new URLSearchParams({
    //   ...(search && { search }),
    //   page: page.toString(),
    //   pageSize: pageSize.toString(),
    // });

    const response = await apiService.get(`/menu/menu-tree`);
    return response.data;
  },
  getParentPage: async () => {
    const response = await apiService.get(`/menulists`);
    return response.data;
  },
  getListByPage: async (pageType) => {
    const response = await apiService.get(`/menulists/${pageType}`);
    return response.data;
  },
  getDetail: async (id) => {
    const response = await apiService.get(`/menu/${id}`);
    return response.data;
  },

  delete: async (id) => {
    const response = await apiService.delete(`/menu/${id}`);
    return response.data;
  },
};

export default MenuSetupService;
